import "isomorphic-fetch";
import ApolloClient from "apollo-boost";
import map from "lodash/map";

function safeApolloError(error) {
  const raw = error && error.message ? error.message : "GraphQL request failed";
  let printable = "";
  for (const character of String(raw).slice(0, 2048)) {
    const code = character.charCodeAt(0);
    printable += code < 32 || code === 127 ? " " : character;
  }
  const singleLine = printable
    .replace(
      /([?&](?:token|key|secret|password|authorization)=)[^&\s]+/gi,
      "$1[redacted]"
    )
    .replace(/(bearer\s+)[^\s]+/gi, "$1[redacted]")
    .replace(/\s+/g, " ")
    .trim();
  return singleLine.length > 512
    ? singleLine.slice(0, 509) + "..."
    : singleLine;
}

export function assertSsrSignalActive(signal) {
  if (!signal || !signal.aborted) return;

  const reason = signal.reason;
  const error = new Error(
    reason && reason.message ? reason.message : "SSR render was aborted"
  );
  error.name = "AbortError";
  error.code = "SSR_RENDER_ABORTED";
  throw error;
}

const baseURL =
  typeof document !== "undefined"
    ? "https://hooliganseyewear.com/index.php?route=extension/module/d_vuefront/graphql&cors=false"
    : "https://hooliganseyewear.com/index.php?route=extension/module/d_vuefront/graphql&cors=false";
export default (ctx, inject) => {
  const client = new ApolloClient({
    uri: baseURL,
    // A request-scoped client is created for every SSR render. Mark it as an
    // SSR client so Apollo does not start browser-only side effects while the
    // server is collecting the page's GraphQL data.
    ssrMode: typeof document === "undefined",
    headers: {
      accept: "application/json; charset=UTF-8",
      "content-type": "application/json; charset=UTF-8",
    },
    onError: (error) => {
      console.error("Apollo request failed:", safeApolloError(error));
    },
    request: (operation) => {
      // apollo-boost 0.4 + isomorphic-fetch can leave an operation pending
      // forever when it receives an AbortSignal that was already aborted.
      // Reject synchronously so the request-level SSR slot always settles.
      assertSsrSignalActive(ctx.ssrSignal);
      const fetchOptions = {
        credentials: "include",
      };
      if (ctx.ssrSignal) fetchOptions.signal = ctx.ssrSignal;
      operation.setContext({
        fetchOptions,
      });

      const headers = {};

      headers["Cookie"] = map(ctx.$cookies.getAll(), (value, index) => {
        let resValue = value;
        if (value !== null && typeof value === "object") {
          resValue = JSON.stringify(resValue);
        }
        return index + "=" + resValue;
      }).join(";");

      operation.setContext({
        headers,
      });
    },
  });

  inject("vfapollo", client);
};
